// react
import React from 'react';
import styled from 'styled-components';

// component
import { ArticleCard, Carousel } from '@/components/atoms';

// store
import { Article, ArticleCategory } from '@karehero/models';

/**
 * ArticleSummary is a helper component that renders the library.
 */
export const ArticleSummary = ({
  library,
  bookmarkedArticles,
  onBookmark,
  isLoading,
}: ArticleSummaryProps) => {
  if (!library || library.length === 0) {
    return null;
  }

  return (
    <>
      {library.map(
        (category) =>
          category?.articles?.length !== 0 && (
            <Carousel
              key={category?.title}
              title={category?.title}
              isLoading={isLoading}
              items={
                category?.articles?.map((article, i) => ({
                  id: article?.title || `${i}`,
                  renderItem: (
                    <StyledArticleCard
                      article={article}
                      isBookmarked={
                        !!bookmarkedArticles?.find(
                          (a) => a?._id === article?._id,
                        )
                      }
                      onBookmark={onBookmark}
                      isLoading={isLoading}
                    />
                  ),
                })) || []
              }
            />
          ),
      )}
    </>
  );
};

const StyledArticleCard = styled(ArticleCard)`
  min-width: 250px;
  width: 250px;
  max-width: 250px;
`;

interface ArticleSummaryProps {
  library?: ArticleCategory[];
  bookmarkedArticles?: Article[];
  onBookmark?: (article: Partial<Article>) => void;
  isLoading: boolean;
}

ArticleSummary.displayName = 'ArticleSummary';

export default ArticleSummary;
